import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';

const hotArticles = [...articles]
  .filter((a) => a.hot)
  .sort((a, b) => b.readCount - a.readCount)
  .slice(0, 8);

const hotTags = [
  '顶流男星', '直播翻车', '人设崩塌', '综艺内幕',
  '选秀黑幕', '带货虚假宣传', '网红产业链', '恋情曝光',
  'MCN机构', '食品安全', '数据造假', '娱乐圈八卦',
];

export default function HotTopics() {
  return (
    <aside className="space-y-6">
      <div className="bg-white rounded-lg border border-background-200 p-5">
        <div className="flex items-center gap-2 mb-4">
          <div className="w-6 h-6 rounded bg-accent-500 flex items-center justify-center">
            <i className="ri-fire-line text-white text-xs"></i>
          </div>
          <h3 className="font-heading text-lg font-bold text-foreground-800">热门爆料</h3>
        </div>
        <div className="space-y-3">
          {hotArticles.map((article, index) => (
            <Link
              key={article.id}
              to={`/article/${article.id}`}
              className="flex gap-3 group cursor-pointer"
            >
              <span className={`flex-shrink-0 w-6 h-6 rounded flex items-center justify-center text-xs font-bold ${
                index < 3 ? 'bg-accent-500 text-white' : 'bg-background-100 text-foreground-400'
              }`}>
                {index + 1}
              </span>
              <span className="text-sm text-foreground-700 line-clamp-2 group-hover:text-primary-500 transition-colors duration-200">
                {article.title}
              </span>
            </Link>
          ))}
        </div>
      </div>

      <div className="bg-white rounded-lg border border-background-200 p-5">
        <div className="flex items-center gap-2 mb-4">
          <div className="w-6 h-6 rounded bg-secondary-500 flex items-center justify-center">
            <i className="ri-price-tag-3-line text-white text-xs"></i>
          </div>
          <h3 className="font-heading text-lg font-bold text-foreground-800">热门标签</h3>
        </div>
        <div className="flex flex-wrap gap-2">
          {hotTags.map((tag) => (
            <span
              key={tag}
              className="px-3 py-1.5 text-xs bg-background-100 text-foreground-600 rounded-full hover:bg-primary-50 hover:text-primary-500 cursor-pointer transition-colors duration-200 whitespace-nowrap"
            >
              {tag}
            </span>
          ))}
        </div>
      </div>
    </aside>
  );
}